import { MERCHANDISE_PRODUCT_TYPE_CODE, SERVICE_CABYS_INIT_DIGITS, SERVICE_PRODUCT_TYPE_CODE } from "./Constants";

/** Largo de un codigo CAByS de Hacienda. */
export const CABYS_CODE_LENGTH = 13;

/** Deja solo los digitos: los archivos exportados traen espacios y separadores. */
export const normalizeCabysCode = (raw?: string | null): string => `${raw ?? ""}`.replace(/\D/g, "");

export const isValidCabysCode = (raw?: string | null): boolean =>
    normalizeCabysCode(raw).length === CABYS_CODE_LENGTH;

/**
 * Si un CAByS corresponde a un servicio o a una mercancia.
 *
 * La clasificacion de Hacienda se lee del primer digito: los que arrancan en 6, 7, 8 o 9
 * son servicios (ver `SERVICE_CABYS_INIT_DIGITS`) y el resto son bienes.
 */
export const productTypeFromCabys = (raw?: string | null): number => {
    const firstDigit = Number(normalizeCabysCode(raw).charAt(0));

    return SERVICE_CABYS_INIT_DIGITS.includes(firstDigit)
        ? SERVICE_PRODUCT_TYPE_CODE
        : MERCHANDISE_PRODUCT_TYPE_CODE;
};

/** Mensaje unico del error de coherencia, reusado por los formularios y por la auditoria. */
export const CABYS_PRODUCT_TYPE_MISMATCH_MESSAGE =
    "El CAByS no corresponde al tipo de producto: los que inician en 6, 7, 8 o 9 son servicios.";

/**
 * Si un CAByS concuerda con el tipo elegido (1 = Mercancia, 2 = Servicio).
 *
 * Devuelve `true` cuando falta alguno de los dos o el CAByS todavia no esta completo:
 * de eso ya se encargan las validaciones de requerido y de 13 digitos, y asi el usuario
 * no ve el error mientras esta tecleando el codigo.
 *
 * El tipo se coacciona con `Number` porque los selects entregan "1"/"2" como string
 * mientras que el modelo lo guarda como entero.
 */
export const isCabysCoherentWithProductType = (
    rawCabys?: string | number | null,
    rawProductType?: string | number | null
): boolean => {
    const cabys = normalizeCabysCode(`${rawCabys ?? ""}`);
    const productType = Number(rawProductType);

    if (!isValidCabysCode(cabys) || !productType) return true;

    return productTypeFromCabys(cabys) === productType;
};
